import { render, staticRenderFns } from "./inter.vue?vue&type=template&id=2e71d3eb&"
import script from "./inter.vue?vue&type=script&lang=js&"
export * from "./inter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports